/* Creating a new instance of the Intl.NumberFormat class. */
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
})
export default formatter;